import React from 'react';
import FilterBar from '../../components/filters/FilterBar';
import PageLayout from '../../components/layout/PageLayout';
import ErrorBoundary from '../../components/ui/ErrorBoundary';
import ChannelAnalytics from '../../components/communication/ChannelAnalytics';
import { useFilterPersistence } from '../../hooks/useFilterPersistence';
import { PAGE_INFO, FILTER_PERIODS } from '../../constants';
import './Communication.css';

/**
 * Communication Analytics Page Component
 * Measure effectiveness of email, push notifications, and in-app messaging
 */
const CommunicationPage = () => {
  const { period, setPeriod } = useFilterPersistence({
    pageKey: 'communication',
    defaultPeriod: FILTER_PERIODS.ALL
  });

  const filters = (
    <FilterBar
      period={period}
      onPeriodChange={setPeriod}
    />
  );

  return (
    <ErrorBoundary>
      <PageLayout
        title={PAGE_INFO.COMMUNICATION.title}
        description={PAGE_INFO.COMMUNICATION.description}
        filters={filters}
      >
        <div className="communication-content">
          <ChannelAnalytics period={period} />
        </div>
      </PageLayout>
    </ErrorBoundary>
  );
};

export default CommunicationPage;

